export const SCREEN_MESSAGE_KEYS = {
  WELCOME: 'welcome',
  ORDER_COMPLETE: 'order_complete',
  PAYMENT_CREDIT_CARDS: 'payment_credit_cards',
  PAYMENT_ZAIN_CASH: 'payment_zain_cash',
  PAYMENT_FAST_PAY: 'payment_fast_pay',
  PAYMENT_WALLET: 'payment_wallet',
  PAYMENT_CASH: 'payment_cash',
  PAYMENT_APS: 'payment_aps',
  PAYMENT_OTHER: 'payment_other',
} as const;

export type ScreenMessageKey =
  (typeof SCREEN_MESSAGE_KEYS)[keyof typeof SCREEN_MESSAGE_KEYS];

export const initialErrors = {
  title: null as string | null,
  body: null as string | null,
  image: null as string | null,
};

export type initialErrorsType = typeof initialErrors;

export const SCREEN_MESSAGE_LANGS = ['main', 'en', 'kr'] as const;
export type ScreenMessageLang = (typeof SCREEN_MESSAGE_LANGS)[number];

export const langLabels: Record<ScreenMessageLang, string> = {
  main: 'AR',
  en: 'EN',
  kr: 'KR',
};

export const langFullNames: Record<ScreenMessageLang, string> = {
  main: 'العربية',
  en: 'English',
  kr: 'کوردی',
};

export const emptyLocalizedText = { main: '', en: '', kr: '' };

export const toLocalizedText = (
  text?: { main?: string | null; en?: string | null; kr?: string | null } | null
): typeof emptyLocalizedText => ({
  main: text?.main ?? '',
  en: text?.en ?? '',
  kr: text?.kr ?? '',
});

export const FIXED_SCREEN_MESSAGE_KEYS: string[] = Object.values(SCREEN_MESSAGE_KEYS);

export const POPUP_SCREENS = [
  'home',
  'addresses',
  'checkout',
  'cart',
  'orders',
  'order_details',
  'profile',
] as const;
export type PopupScreen = (typeof POPUP_SCREENS)[number];

export const POPUP_SCREEN_LABELS: Record<PopupScreen, string> = {
  home: 'Home',
  addresses: 'Addresses',
  checkout: 'Checkout',
  cart: 'Cart',
  orders: 'Orders',
  order_details: 'Order Details',
  profile: 'Profile',
};

export const POPUP_TRIGGERS = ['onOpen', 'onAction'] as const;
export type PopupTrigger = (typeof POPUP_TRIGGERS)[number];

export const POPUP_TRIGGER_LABELS: Record<PopupTrigger, string> = {
  onOpen: 'On open',
  onAction: 'On action (by key)',
};

export const POPUP_PLATFORMS = ['all', 'ios', 'android'] as const;
export type PopupPlatform = (typeof POPUP_PLATFORMS)[number];

export const POPUP_PLATFORM_LABELS: Record<PopupPlatform, string> = {
  all: 'All',
  ios: 'iOS',
  android: 'Android',
};

export const POPUP_ACTIONS = [
  'dismiss',
  'update_address',
  'open_screen',
  'open_url',
  'update_app',
] as const;
export type PopupAction = (typeof POPUP_ACTIONS)[number];

export const POPUP_ACTION_LABELS: Record<PopupAction, string> = {
  dismiss: 'Dismiss',
  update_address: 'Update address',
  open_screen: 'Open screen',
  open_url: 'Open URL',
  update_app: 'Update app',
};

export const POPUP_MAX_ACTIONS = 2;

export const POPUP_KEY_PATTERN = /^[a-z0-9_]{3,60}$/;

export const POPUP_VERSION_PATTERN = /^\d+\.\d+\.\d+$/;

export const initialPopupErrors = {
  key: null as string | null,
  title: null as string | null,
  screens: null as string | null,
  minAppVersion: null as string | null,
  maxAppVersion: null as string | null,
  endAt: null as string | null,
  actions: [] as (string | null)[],
};

export type PopupErrors = typeof initialPopupErrors;
